import Chip from '@material-ui/core/Chip';
import { Box } from '@material-ui/core';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';

export const SupervisorField = props => {
  if (!props.record?.supervisorFullNames) return <></>;
  const supervisorsArray = props.record.supervisorFullNames.split(',');
  return (
    <Box
      display="flex"
      alignItems="center"
      onClick={e => {
        if (!props.onClick) return;
        e.stopPropagation();
        props.onClick(props.record);
      }}
    >
      <Box display="flex" flexWrap="wrap">
        {supervisorsArray.map(item => (
          <Chip style={{ margin: '5px 5px' }} key={item} label={item} />
        ))}
      </Box>
      {props.icon && <PeopleAltIcon />}
    </Box>
  );
};
